// React imports.
import React from "react";



const Assessment3DropOffTable = ({ fuelType, step, state }) => (
    <div>
        <strong>Supplemental Investigations– Results Overview</strong>
        <br/>
        Below is a breakdown of the number of households “dropped” at each stage of the collection and recording process.
        <ul>
            <li>
                Start: You started with a total of {fuelType.numHouseholds.toLocaleString()} assisted households.
            </li>
            {step > 1
            &&
                <li>
                    Stage 1: You missed out on the data for  {fuelType.numHouseholdsVendorNotSelected.toLocaleString()} 
                     &nbsp;({fuelType.percentHouseholdsVendorNotSelected} of total) because
                    you did not request data from the vendors that serve those households.
                </li>
            }
        
            {step > 2
            &&
                <li>
                    Stage 2: You missed out on the data for {fuelType.numHouseholdsSelectedVendorNotProvidingData.toLocaleString()} 
                     &nbsp;({fuelType.percentHouseholdsSelectedVendorNotProvidingData} of total) because the vendors that serve those households
                    did not comply with your data request.

                </li>
            }
        
            {step > 3
            &&
                <li>
                    Stage 3: You missed out on the data for {fuelType.numHouseholdsVendorNotEnoughProvidingData.toLocaleString()}
                     &nbsp;({fuelType.percentHouseholdsVendorNotEnoughProvidingData} of total) because some of the vendors who complied with your
                    data request did not supply the data for all of the households that they serve.
                </li>
            }
        </ul>
        <div className="grid-container">
            <div className="grid-item item1 header">Main Heating Fuel</div>
            <div className="grid-item item2 header">Total Assisted HHs</div>

            {step > 1
              &&<div className="grid-item item3 header">HHs Represented by Vendors Selected for Data Collection</div>
            }
        
            {step > 2
            &&
                <div className="grid-item item4 header">HHs Represented by Vendors Providing Data</div>
            }
            {step > 3
            &&
                <div className="grid-item item5 header">HHs for Whom Data was Received</div>
            }
    
            <div className="grid-item header item6">#</div>
            <div className="grid-item header item7">%</div>
            {step > 1
            &&<React.Fragment>
                <div className="grid-item header item8">#</div>
                <div className="grid-item header item9">%</div>
            </React.Fragment>}
            {step > 2
            &&<React.Fragment>  
                <div className="grid-item header item10">#</div>
                <div className="grid-item header item11">%</div>
            </React.Fragment>}  
            {step > 3
            &&<React.Fragment>  
                <div className="grid-item header item12">#</div>
                <div className="grid-item header item13">%</div>
            </React.Fragment>}  
    
            <div className="grid-item dwGridRow item14">{fuelType.description}</div>
            <div className="grid-item dwGridRow item15">{fuelType.numHouseholds.toLocaleString()}</div>
            <div className="grid-item dwGridRow item16">100%</div>
            {step > 1
            &&<React.Fragment>
              <div className="grid-item dwGridRow item17">{fuelType.numHouseholdsServedByVendorsSelected.toLocaleString()}</div>
              <div className="grid-item dwGridRow item18">{fuelType.percentHouseholdsServedByVendorsSelected}</div>
            </React.Fragment>}  
            {step > 2
            &&<React.Fragment>
              <div className="grid-item dwGridRow item19">{fuelType.numHouseholdsServedByVendorsProvidingData.toLocaleString()}</div>
              <div className="grid-item dwGridRow item20">{fuelType.percentHouseholdsServedByVendorsProvidingData}</div>
            </React.Fragment>}  
            {step > 3
            &&<React.Fragment>
                <div className="grid-item dwGridRow item21">{fuelType.numHouseholdsDataReceived.toLocaleString()}</div>
                <div className="grid-item dwGridRow item22">{fuelType.percentHouseholdsDataReceived}</div>
            </React.Fragment>}  
            <div className="item23">
                <div className="lev2-grid-container">
                    {step > 1
                    &&<React.Fragment>
                        <div  className="lev3-grid-container">
                        <div className="lev4-grid-container">
                            <div> </div>
                            <div className="left-arrow"> </div>
                            <div> </div>
                            <div> </div>   
                        </div>
                        <div className="orange-block">
                            <div className="orange-block-header">Stage 1: HHs with Data Missing Because their Vendors were NOT Selected for Collection</div>
                            <div className="lev4-grid-container">
                                <div className="white-border row1 col1">#</div>
                                <div className="white-border row1 col2">%</div>
                                <div className="white-border row2 col1">{fuelType.numHouseholdsVendorNotSelected.toLocaleString()}</div>
                                <div className="white-border row2 col2">{fuelType.percentHouseholdsVendorNotSelected}</div>
                            </div>
                        </div>
                        <div className="lev4-grid-container">
                            <div  className="right-arrow"> </div>
                            <div> </div>
                            <div> </div>
                            <div> </div>   
                        </div>
                    </div>
                    </React.Fragment>}  
                    {step > 2
                    &&<React.Fragment>
                        <div  className="lev3-grid-container">
                        <div className="lev4-grid-container">
                            <div> </div>
                            <div className="left-arrow"> </div>
                            <div> </div>
                            <div> </div>   
                        </div>
                        <div className="orange-block" >
                            <div className="orange-block-header">Stage 2: HHs with Data Missing Because their Vendor did NOT Comply with the Data Request</div>
                            <div className="lev4-grid-container">
                                <div className="white-border row1 col1">#</div>
                                <div className="white-border row1 col2">%</div>
                                <div className="white-border row2 col1">{fuelType.numHouseholdsSelectedVendorNotProvidingData.toLocaleString()}</div>
                                <div className="white-border row2 col2">{fuelType.percentHouseholdsSelectedVendorNotProvidingData}</div>
                            </div>
                        </div>
                        <div className="lev4-grid-container">
                            <div className="right-arrow"> </div>
                            <div> </div>
                            <div> </div>
                            <div> </div>   
                        </div>
                    </div>
                    </React.Fragment>}  
                    {step > 3
                    &&<React.Fragment>
                        <div  className="lev3-grid-container">
                        <div className="lev4-grid-container">
                            <div> </div>
                            <div className="left-arrow"> </div>
                            <div> </div>
                            <div> </div>   
                        </div>
                        <div className="orange-block" >
                            <div className="orange-block-header">Stage 3: HHs with Data Missing Because Vendors Did Not Furnish Data for Enough of their Clients</div>
                            <div className="lev4-grid-container">
                                <div className="white-border row1 col1">#</div>
                                <div className="white-border row1 col2">%</div>
                                <div className="white-border row2 col1">{fuelType.numHouseholdsVendorNotEnoughProvidingData.toLocaleString()}</div>
                                <div className="white-border row2 col2">{fuelType.percentHouseholdsVendorNotEnoughProvidingData}</div>
                            </div>
                        </div>
                        <div className="lev4-grid-container">
                            <div  className="right-arrow"> </div>
                            <div> </div>
                            <div> </div>
                            <div> </div>   
                        </div>
                    </div>
                    </React.Fragment>}  
                </div>
            </div>
        </div>
        {step > 4
        &&
        <React.Fragment>
            <p>
                <br/>
                As you can see above, you ultimately fell below the {fuelType.targetPercentHouseholdsCoveredString} threshold at Stage 3 because some of your
                vendors did not supply data for all of the households they serve. That said, this would not have
                been an issue if you hadn’t missed out on collecting data at earlier points along the process.
                For example, you could have requested data from more vendors or worked to increase the number of
                vendors complying with your data requests. 
            </p>
            <p>
                Which of the following action items would you like to pursue in order to ensure that you
                receive data from an adequate number of households in the future? In the box below, please
                indicate why you think those particular actions would be most effective as well as any
                ideas as to how you might go about implementing those changes to your program.
            </p>
            <ul>
                <li>
                    <label>
                        <input
                          name="increaseNumberOfVendorsSelectedFlag"
                          id="increaseNumberOfVendorsSelectedFlag"
                          type="checkbox"
                          checked={fuelType.increaseNumberOfVendorsSelectedFlag}
                          onChange={(changeEvent) => state.assessment3FieldChangeHandler(changeEvent, fuelType)} />
                        &nbsp;Increase the number of {fuelType.description}&nbsp;vendors selected for data collection.
                  </label>
                </li>
                <li>
                    <label>
                        <input
                          name="increaseNumberOfVendorsProvidingFlag"
                          id="increaseNumberOfVendorsProvidingFlag"
                          type="checkbox"
                          checked={fuelType.increaseNumberOfVendorsProvidingFlag}
                          onChange={(changeEvent) => state.assessment3FieldChangeHandler(changeEvent, fuelType)} />
                        &nbsp;Work to increase the number of {fuelType.description}&nbsp;vendors who comply with requests for data collection.
                  </label>
                </li>
                <li>
                    <label>
                        <input
                          name="increaseRateOfReturnFlag"
                          id="increaseRateOfReturnFlag"
                          type="checkbox"
                          checked={fuelType.increaseRateOfReturnFlag}
                          onChange={(changeEvent) => state.assessment3FieldChangeHandler(changeEvent, fuelType)} />
                        &nbsp;Work with vendors to ensure that they are providing data for as many of the households they serve as possible.
                    </label>
                </li>
            </ul>

            <br/>
            <textarea  name="increaseDataDesc"
                id="increaseDataDesc" style={{width:"100%"}}
                value={fuelType.increaseDataDesc}
                onChange={(changeEvent) => state.assessment3FieldChangeHandler(changeEvent, fuelType)}></textarea>
        </React.Fragment>
        }
    </div>
);

export default Assessment3DropOffTable;
